export default __webpack_public_path__ + "04cae1e6d71fce7cf2d568d32d112ba2.png";